// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill';
// import 'url-search-params-polyfill'
import Vue from "vue";
import "babel-polyfill";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
// import VConsole from 'vconsole'
// new VConsole()


import { message } from "@/utils/resetMessage";
import "element-ui/lib/theme-chalk/index.css";
import statistics from "./utils/statistics";

// 过滤器
import * as _filter from "./utils/filter";
// 统计
import $ from "jquery";
Object.keys(_filter).forEach(item => {
  Vue.filter(item, _filter[item]);
});
// 音频
import vueAplayer from "vue-aplayer";
Vue.use(vueAplayer);
Vue.use(ElementUI);
Vue.prototype.$ba = statistics;
Vue.prototype.$message = message;
Vue.config.productionTip = false;
// base64
// Vue.prototype.Base64 = require('js-base64').Base64
// sessionStrore
Vue.prototype.resetSetItem = function(key, newVal) {
  if (
    key === "isLogin" ||
    key === "Authorization" ||
    key === "isActive" ||
    key === "userInfo" ||
    key === "getFixeds" ||
    key === "uuidv4" ||
    key === "address_code"
  ) {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: function(k, val) {
        localStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent(
          "setItem",
          false,
          false,
          k,
          null,
          val,
          null,
          null
        );

        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    };
    return storage.setItem(key, newVal);
  }
};

// 解决页面刷新参数不全问题
Vue.prototype.resetParams = function(_this, arr) {
  let reg = new RegExp("/", "g"); //g代表全部
  let newPath = _this.$route.path.replace(reg, "_");
  var _data = _this.$data;
  var flag = false;
  if (arr.length > 0) {
    for (let i in _data) {
      var item = _data[i];
      if (arr.indexOf(i) >= 0) {
        if (item == "" || item == null || item == undefined) {
        } else {
          flag = true;
        }
      }
    }
    if (flag == true) {
      for (let i in _data) {
        var item = _data[i];
        if (arr.indexOf(i) >= 0) {
          if (item == "" || item == null || item == undefined) {
            _this[i] = localStorage.removeItem(newPath + "_" + i);
          } else {
            localStorage.setItem(newPath + "_" + i, item);
          }
        }
      }
    } else {
      for (let i in _data) {
        var item = _data[i];
        if (arr.indexOf(i) >= 0) {
          if (item == "" || item == null || item == undefined) {
            _this[i] = localStorage.getItem(newPath + "_" + i);
          }
        }
      }
    }
  }
  // return _data
};

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js